<template>
  <div class="orders-wrapper">
    <BasisNav
      nav-title="我的订单"
      :back="back"
    />
    <van-tabs
      v-model="activeTab"
      sticky
    >
      <template v-for="name in tabs">
        <van-tab :key="name" :title="name" :name="name">
          <basis-list-wrapper
            target-key="orders"
            :extra-keys="stateType[name]"
          >
            <template v-slot:item="{item}">
              <order-item
                :item="item"
                @pay="(callback) => payHandler(item, callback)"
              />
            </template>
          </basis-list-wrapper>
        </van-tab>
      </template>
    </van-tabs>
    <div class="overlay-wrapper">
      <wx-pay-overlay
        :overlay-status.sync="showWxPayOverlay"
        :qrcode="wxPayQrcode"
        @successed="$router.go(0)"
      />
    </div>
  </div>
</template>

<script>
import { BasisNav, BasisListWrapper } from '@/components/basis'
import WxPayOverlay from '@/components/wx'
import OrderItem from './components/OrderItem'
import { isWechatBrowser, onBridgeReady } from '@/utils/wechat'
import { wxPayENV } from '@/config/wx.config'
import { Orders } from '@/api'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'Orders',
  components: { BasisNav, BasisListWrapper, WxPayOverlay, OrderItem },
  mixins: [mixinWxShare],
  data: () => ({
    tabs: [
      '全部',
      '待发货',
      '已完成'
    ],
    // paying, payed, completed, canceled
    stateType: {
      '待付款': {
        state: 'paying'
      },
      '待发货': {
        state: 'payed'
      },
      '已完成': {
        state: 'completed'
      }
    },
    activeTab: '全部',
    showWxPayOverlay: false,
    wxPayQrcode: ''
  }),
  methods: {
    back () {
      this.$router.push({
        name: 'studio-user'
      })
    },
    async payHandler (item, callback) {
      try {
        const { wxPayPayload, wxPayQrcode, wxPayUrl } = await Orders.pay({
          id: item.id,
          payType: 'cash'
        })
        callback()
        switch (isWechatBrowser()) {
          case true:
            // 微信浏览器
            onBridgeReady(wxPayPayload).then(() => {
              this.$notify({ type: 'success', message: '支付成功' })
              this.$router.go(0)
            }).catch(() => {
              this.$notify({ type: 'danger', message: '支付失败' })
            })
            break
          case false:
            // 普通浏览器
            this.showWxPayOverlay = true
            if (wxPayENV === 'NATIVE') {
              this.wxPayQrcode = wxPayQrcode
            } else {
              window.location = wxPayUrl
            }
            break
        }
      } catch (error) {
        callback()
        console.log(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.orders-wrapper {
  @include mh-bgc(100vh, $color-bg);
  .van-tabs {
    ::v-deep {
      .van-tabs__wrap {
        border-radius: 0 0 8px 8px;
        &[class*='van-hairline']::after {
          display: none;
        }
        .van-tabs__line {
          @include wh(32px !important, 4px);
          @include lg-radius(#E6AC67, #F5C993);
          bottom: 20px;
          background-color: $color-text-active;
        }
      }
    }
    .order-item {
      margin-top: 16px;
    }
  }
  .wx-pay-overlay {
    ::v-deep {
      .van-overlay {
        z-index: 99;
      }
    }
  }
}
</style>
